<template>
  <div>
    <!-- 弹窗开始-->
    <div data-v-e7887d8e class="actModules">
      <div class="follow_content">
        <div>
          <h3 class="actModules_title" :style="titleStyle">
            {{ bgImg }}
          </h3>
          <div class="follow_codeImg">
            <img :src="imgRQ.value" />
          </div>
          <!-- <a href="javascript:;" class="follow_codeLink">去看看</a> -->
        </div>
      </div>
    </div>
    <!-- 弹窗结束-->
  </div>
</template>

<script>
import '../../assets/css/reset.css';

export default {
	name: 'h5-QRCode',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			imgRQ: '二维码',
			bgImg: '标题图片地址'
		}
	},
	data () {
		return {
			modulesTitle: '更多福利敬请关注心悦俱乐部App'
		};
	},
	props: {
		imgRQ: {
			type: Object,
			default: () => ({
				class: 'image',
				value: ''
			})
		},
		bgImg: {
			type: String,
			default: '更多福利敬请关注心悦俱乐部App'
		}
	},
	computed: {
		titleStyle () {
			if (this.bgImg === '') {
				return {};
			} else {
				return {
					background: `url(${this.bgImg}) no-repeat`,
					'background-size': '100% 100%'
				};
			}
		}
	},
	methods: {
		modalClose: function () {
			this.isShow = false;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";

.followTitle {
  font-size: 0.3rem;
  text-align: center;
  margin-top: 0.7rem;
}

.follow_footer {
  text-align: center;
}

.follow_footerBtn {
  height: 0.7rem;
  line-height: 0.7rem;
  width: 2.4rem;
  background: #e27f7f;
  @extend %inline-block;
  font-size: 0.28rem;
  color: #4a4a4a;
  margin: 0.34rem 0.16rem 0;
}

.follow_content {
  padding-bottom: 0.44rem;
}

.follow_codeImg {
  width: 2.4rem;
  height: 2.4rem;
  margin: 0 auto 0.3rem;

  img {
    width: 100%;
    height: 100%;
    @extend %block;
  }
}

.follow_codeLink {
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  margin-top: 0.2rem;
  @extend %block;
  margin: 0.2rem auto 0;
  width: 3rem;
  background: #979797;
  padding: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/localCom/x-QRCode.vue